"use client";

import { createContext, type ReactNode } from "react";
import type { UiLabelsOverrides } from "./UiLabels.types";

export const UiLabelsContext = createContext<UiLabelsOverrides>({});

export interface UiLabelsProviderProps {
  labels: UiLabelsOverrides;
  children: ReactNode;
}

export const UiLabelsProvider = ({ labels, children }: UiLabelsProviderProps) => (
  <UiLabelsContext.Provider value={labels}>{children}</UiLabelsContext.Provider>
);
